import {Component, Inject, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators,} from '@angular/forms';
import {MatButton} from '@angular/material/button';

import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';

import {Tag} from '@app/tag/models';

@Component({
    selector: 'frog-edit-tag-dialog',
    templateUrl: './edit-tag-dialog.component.html',
    styleUrls: ['./edit-tag-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class EditTagDialogComponent implements OnInit {
    public form: UntypedFormGroup;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<EditTagDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Tag,
    ) {
        this.form = this.formBuilder.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
        });
    }

    ngOnInit(): void {
        this.form.setValue({
            name: this.data.displayName,
        });
    }

    save() {
        this.dialogRef.close(this.form.value.name);
    }
}
